class ChurchKey {
  ChurchName = "church_name";
  ChurchIntroduction = "church_introduction";
  ChurchImagesName = "church_images_name";
  ChurchId = "church_id";
  ChurchPersonCreate = "church_person_create";
  ChurchUserJoin = "church_user_join";
  ChurchUserPending = "church_user_pending";
  ChurchCreatedAt = "church_created_at";
  ChurchUpdatedAt = "church_updated_at";
  ChurchDeletedAt = "church_deleted_at";
  ChurchStatus = "church_status";
  ChurchType = "church_type";
}

export default new ChurchKey();
